import type { TOC } from '@ember/component/template-only';

interface UiPaginationLabelSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="inline-block" data-test-ui-pagination-label ...attributes>
    {{yield}}
  </div>
</template> satisfies TOC<UiPaginationLabelSignature>;
